import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCodeBookImportQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetCodeBookImportQuery = { __typename?: 'query_root', code_book_imports_by_pk?: { __typename?: 'code_book_imports', id: any, abbreviation: string, edition_year?: number | null, title: string, publisher?: string | null, book_type: string, status: string, error_message?: string | null, page_count?: number | null, section_count?: number | null, printed_as_provision?: number | null, not_captured?: number | null, missing_parents?: number | null, figure_count?: number | null, commentary_family?: string | null, source_file_name?: string | null, source_file_url: string, code_book_id?: any | null, published_at?: any | null, created_at: any, jurisdiction_record?: { __typename?: 'jurisdictions', id: any, name: string } | null, amends_code_book?: { __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null } | null, sections: Array<{ __typename?: 'code_book_import_sections', id: any, section_number: string, title?: string | null, body: string, commentary?: string | null, chapter_number?: string | null, chapter_title?: string | null, page_number?: number | null, depth: number, has_images: boolean, change?: string | null }>, orphaned_links: Array<{ __typename?: 'code_section_link_orphans', id: any, section_number: string, section_title?: string | null, citation_text?: string | null, origin: string, recoverable_from_text: boolean, plan_review_requirement: { __typename?: 'plan_review_requirements', id: any, code?: string | null, title: string } }> } | null };


export const GetCodeBookImportDocument = gql`
    query getCodeBookImport($id: uuid!) {
  code_book_imports_by_pk(id: $id) {
    id
    abbreviation
    edition_year
    title
    publisher
    book_type
    status
    error_message
    page_count
    section_count
    printed_as_provision
    not_captured
    missing_parents
    figure_count
    commentary_family
    source_file_name
    source_file_url
    code_book_id
    published_at
    created_at
    jurisdiction_record {
      id
      name
    }
    amends_code_book {
      id
      abbreviation
      edition_year
    }
    sections(order_by: {sort_key: asc}) {
      id
      section_number
      title
      body
      commentary
      chapter_number
      chapter_title
      page_number
      depth
      has_images
      change
    }
    orphaned_links(where: {resolved_at: {_is_null: true}}) {
      id
      section_number
      section_title
      citation_text
      origin
      recoverable_from_text
      plan_review_requirement {
        id
        code
        title
      }
    }
  }
}
    `;

/**
 * __useGetCodeBookImportQuery__
 *
 * To run a query within a React component, call `useGetCodeBookImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeBookImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeBookImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCodeBookImportQuery(baseOptions: Apollo.QueryHookOptions<GetCodeBookImportQuery, GetCodeBookImportQueryVariables> & ({ variables: GetCodeBookImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>(GetCodeBookImportDocument, options);
      }
export function useGetCodeBookImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>(GetCodeBookImportDocument, options);
        }
export function useGetCodeBookImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>(GetCodeBookImportDocument, options);
        }
export type GetCodeBookImportQueryHookResult = ReturnType<typeof useGetCodeBookImportQuery>;
export type GetCodeBookImportLazyQueryHookResult = ReturnType<typeof useGetCodeBookImportLazyQuery>;
export type GetCodeBookImportSuspenseQueryHookResult = ReturnType<typeof useGetCodeBookImportSuspenseQuery>;
export type GetCodeBookImportQueryResult = Apollo.QueryResult<GetCodeBookImportQuery, GetCodeBookImportQueryVariables>;